<template>
  <div class="team-card-parts">
    <figure class="team-card-parts__img">
      <img :src="imgPath" alt="" />
    </figure>

    <div class="team-card-parts__data">
      <p class="team-card-parts__data__name" v-html="name || $t('common.favoriteNotSet')"></p>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'

/**
 * チーム 表示パーツ
 * todo: デザイン調整 / props設定 / emit等
 */
export default defineComponent({
  name: 'TeamCardParts',
  props: {
    img: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    /**
     * imgPath
     * @param {string} val 画像データパス
     */
    const imgPath = computed({
      get: () => props.img || './assets/img/common/card/icon_team__null.svg',
      set: (val: string) => val,
    })

    return {
      imgPath,
    }
  },
})
</script>

<style lang="scss" scoped>
.team-card-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__img {
    img {
      width: 48px;
      height: 48px;
      object-fit: cover;
      border-radius: 2px;
    }
  }

  &__data {
    width: calc(100% - 64px);
    text-align: left;

    &__name {
      @include fontSetTextMedium();

      font-weight: 600;
      line-height: 1.38;
      color: $black;
    }
  }
}
</style>
